import { useQuery } from '@tanstack/react-query';
import { useFlags } from 'src/feature-flags/FlagsHook';
import { ChatSkill } from './skillCommands';

export const CHAT_SKILLS_QUERY_KEY = ['chat', 'skills'] as const;

export function useChatSkills() {
  const { flagEnabledSiestaSlashSkillCommands } = useFlags();
  return useQuery<ChatSkill[]>({
    queryKey: CHAT_SKILLS_QUERY_KEY,
    // The route 404s while the flag is off, and the flag reads undefined until LaunchDarkly has
    // initialised, so only a definite true may fetch.
    enabled: flagEnabledSiestaSlashSkillCommands === true,
    staleTime: 5 * 60 * 1000,
  });
}
